module.exports = __webpack_public_path__ + "img/646.c9674f6c.png";